/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FragmentNames {
  ACCOUNT_ACTIVATION = 'account-activation',
  ACCOUNT_CREATION_COMPLETED = 'account-creation-completed',
  ACCOUNT_CREATION_CONFIRMATION_SMS_CODE = 'account-creation-confirmation-sms-code',
  ACCOUNT_CREATION_MODAL = 'account-creation-modal',
  ACCOUNT_CREATION_PRIVACY_MODAL = 'account-creation-privacy-modal',
  ACCOUNT_CREATION_PROCESSING = 'account-creation-processing',
  ACCOUNT_CREATION_STEPS = 'account-creation-steps',
  ACCOUNT_CREATION_TERMS_MODAL = 'account-creation-terms-modal',
  ALERT_QUIZ = 'alert-quiz',
  ALTERNATIVE_LOGIN = 'alternative-login',
  ANOTHER_PERIOD = 'another-period',
  APP = 'app',
  APPOINTMENT_CANCEL = 'appointment-cancel',
  APPOINTMENT_CREATION_CHOOSE_ANOTHER_DATE = 'appointment-creation-choose-another-date',
  APPOINTMENT_DETAIL = 'appointment-detail',
  APPOINTMENT_DETAIL_SUMMARY = 'appointment-detail-summary',
  APPOINTMENTS = 'appointments',
  APPOINTMENTS_LIST = 'appointments-list',
  ASK_THE_PHYSICIAN = 'ask-the-physician',
  ASSIGN_PRIVACY_MODAL = 'assign-privacy-modal',
  AUTO_LOGOUT_INACTIVITY = 'auto-logout-inactivity',
  CHANGE_EXPIRED_PASSWORD = 'change-expired-password',
  CHANGE_PASSWORD = 'change-password',
  CHANGE_USER_MODAL = 'change-user-modal',
  CONSENT_FORM = 'consent-form',
  COOKIE = 'cookie',
  CREATE_USER_FROM_WEB_LABORATORY = 'create-user-from-web-laboratory',
  DASHBOARD = 'dashboard',
  EXAM_DETAILS = 'exam-details',
  EXAM_DETAILS_ITEM = 'exam-details-item',
  EXAM_LAB_DETAILS = 'exam-lab-details',
  EXAM_REPORT_MODAL = 'exam-report-modal',
  EXAM_RESULTS = 'exam-results',
  FILE_ITEM = 'file-item',
  FOOTER = 'footer',
  FOOTER_TITLE = 'footer-title',
  FORGET_PASSWORD = 'forget-password',
  FORGET_PASSWORD_REQUEST_FAILURE = 'forget-password-request-failure',
  FORGET_PASSWORD_REQUEST_SUCCESS = 'forget-password-request-success',
  GUIDANCE_AND_REGULATORY_MODAL = 'guidance-and-regulatory-modal',
  GUIDANCE_TO_THE_PATIENT = 'guidance-to-the-patient',
  HEALTH_INFORMATION = 'health-information',
  IFRAME_TELECONSULTA = 'iframe-teleconsulta',
  IFRAME_TELECONSULTATION = 'iframe-teleconsultation',
  INFORMATION = 'information',
  INSTITUTIONAL_MATERIAL = 'institutional-material',
  INSTRUCTIONS = 'instructions',
  INSURANCE_AUTOCOMPLETE_MODAL = 'insurance-autocomplete-modal',
  INSURANCES_FORM = 'insurances-form',
  JUSTIFY_MODAL = 'justify-modal',
  LIST_TERMS_OF_USE = 'list-terms-of-use',
  LOGIN = 'login',
  LOGIN_LANDING_PAGE = 'login-landing-page',
  LOGIN_SWITCH = 'login-switch',
  MATERIAL_EDUCATIONAL = 'material-educational',
  MATERIAL_EDUCATIONAL_DETAIL = 'material-educational-detail',
  MEASUREMENTS_CARD = 'measurements-card',
  MY_CHART_ALLERGIE_DETAIL = 'my-chart-allergie-detail',
  MY_CHART_ALLERGIE_INTOLERANCE = 'my-chart-allergie-intolerance',
  MY_CHART_ALLERGIES = 'my-chart-allergies',
  MY_CHART_DISCHARGE_SUMMARY = 'my-chart-discharge-summary',
  MY_CHART_DISCHARGE_SUMMARY_DETAILS = 'my-chart-discharge-summary-details',
  MY_CHART_DOCUMENT = 'my-chart-document',
  MY_CHART_MAIN = 'my-chart-main',
  MY_CHART_MEDICAL_DATA_REPORT = 'my-chart-medical-data-report',
  MY_CHART_MEDICINE = 'my-chart-medicine',
  MY_CHART_MEDICINE_DETAIL = 'my-chart-medicine-detail',
  MY_CHART_MEDICINE_HOSPITAL_DETAIL = 'my-chart-medicine-hospital-detail',
  MY_CHART_MEDICINE_INACTIVATE = 'my-chart-medicine-inactivate',
  MY_CHART_MEDICINE_PATIENT = 'my-chart-medicine-patient',
  MY_CHART_MEDICINE_PATIENT_DETAIL = 'my-chart-medicine-patient-detail',
  MY_CHART_MEDICINES_IN_USE = 'my-chart-medicines-in-use',
  MY_CHART_PAST_HISTORY = 'my-chart-past-history',
  MY_CHART_PAST_HISTORY_HOSPITAL = 'my-chart-past-history-hospital',
  MY_CHART_PAST_HISTORY_INACTIVATE = 'my-chart-past-history-inactivate',
  MY_CHART_PAST_HISTORY_PATIENT = 'my-chart-past-history-patient',
  MY_CHART_PRESCRIPTIONS = 'my-chart-prescriptions',
  MY_CHART_SEND_NEW_DOCUMENT = 'my-chart-send-new-document',
  MY_CHART_SENDING_DOCUMENTS = 'my-chart-sending-documents',
  MY_CHART_SICK_NOTE = 'my-chart-sick-note',
  MY_CHART_TELEHEALTH_RECORDS = 'my-chart-telehealth-records',
  MY_CHART_VACCINES = 'my-chart-vaccines',
  MY_CHART_VACCINES_DETAIL = 'my-chart-vaccines-detail',
  MY_CHART_VIEW_SENT_DOCUMENT = 'my-chart-view-sent-document',
  MY_CHART_VIEW_TELECONSULTATION_RECORD = 'my-chart-view-teleconsultation-record',
  PASSWORD_RESET = 'password-reset',
  PATIENT_QUESTIONS_MODAL = 'patient-questions-modal',
  PATIENT_ROOT = 'patient-root',
  PAYMENT_LIST = 'payment-list',
  PAYMENT_SUMMARY = 'payment-summary',
  PERSONAL_CONTACT = 'personal-contact',
  PERSONAL_INFORMATION = 'personal-information',
  PREVIEW_ATTACHED_FILE = 'preview-attached-file',
  PRINT_MODAL = 'print-modal',
  PRIVACY = 'privacy',
  PRIVACY_MODAL = 'privacy-modal',
  PROFILE = 'profile',
  PROFILE_PRIVACY = 'profile-privacy',
  PROFILE_UPDATE = 'profile-update',
  PSEUDONYM_APPOINTMENTS = 'pseudonym-appointments',
  PSEUDONYM_APPOINTMENTS_CANCEL = 'pseudonym-appointments-cancel',
  PSEUDONYM_APPOINTMENTS_CONFIRMATION = 'pseudonym-appointments-confirmation',
  PSEUDONYM_APPOINTMENTS_CONFIRMATION_DETAIL = 'pseudonym-appointments-confirmation-detail',
  PSEUDONYM_APPOINTMENTS_CONFIRMATION_DETAIL_SUMMARY = 'pseudonym-appointments-confirmation-detail-summary',
  PSEUDONYM_APPOINTMENTS_PRINT_MODAL = 'pseudonym-appointments-print-modal',
  PSEUDONYM_APPOINTMENTS_QUIZ_ANSWER_VIEW = 'pseudonym-appointments-quiz-answer-view',
  PSEUDONYM_APPOINTMENTS_STEP_1 = 'pseudonym-appointments-step-1',
  PSEUDONYM_APPOINTMENTS_STEP_2 = 'pseudonym-appointments-step-2',
  PSEUDONYM_APPOINTMENTS_STEP_3 = 'pseudonym-appointments-step-3',
  PSEUDONYM_APPOINTMENTS_STEP_4 = 'pseudonym-appointments-step-4',
  PSEUDONYM_APPOINTMENTS_STEP_5 = 'pseudonym-appointments-step-5',
  PSEUDONYM_APPOINTMENTS_STEP_6 = 'pseudonym-appointments-step-6',
  PSEUDONYM_APPOINTMENTS_STEP_7 = 'pseudonym-appointments-step-7',
  PSEUDONYM_APPOINTMENTS_STEP_8 = 'pseudonym-appointments-step-8',
  PSEUDONYM_APPOINTMENTS_STEP_DOCUMENT_UPLOAD = 'pseudonym-appointments-step-document-upload',
  PSEUDONYM_SCHEDULING_WAITING_LIST = 'pseudonym-scheduling-waiting-list',
  PSEUDONYM_SUGGESTION_CHECK_AVAILABLE = 'pseudonym-suggestion-check-available',
  PSEUDONYM_SUGGESTION_CHOOSE_ANOTHER_DATE = 'pseudonym-suggestion-choose-another-date',
  PSEUDONYM_SUGGESTION_LIST = 'pseudonym-suggestion-list',
  PSEUDONYM_SUGGESTION_TYPE_CONSULTATION = 'pseudonym-suggestion-type-consultation',
  PUBLIC_SCHEDULING_ACTIONS = 'public-scheduling-actions',
  QUESTIONNAIRE = 'questionnaire',
  QUIZ_QUESTION_ANSWER_VIEW = 'quiz-question-answer-view',
  RAW_PROFILE_LAYOUT = 'raw-profile-layout',
  REQUEST_DATE = 'request-date',
  REQUESTCHANGE = 'requestchange',
  RESCHEDULE_TRANSFERENCE_MODAL = 'reschedule-transference-modal',
  RESET_PASSWORD_REQUEST_FAILURE_AND_EXPIRED = 'reset-password-request-failure-and-expired',
  RESET_PASSWORD_REQUEST_SUCCESS = 'reset-password-request-success',
  SCHEDULE_CONFIRMATION = 'schedule-confirmation',
  SCHEDULING_WAITING_LIST = 'scheduling-waiting-list',
  SCRATCHDASHBOARD = 'scratchdashboard',
  SEGMENTED_CONTROL = 'segmented-control',
  SEND_MAIL = 'send-mail',
  SEND_MAIL_MODAL = 'send-mail-modal',
  SEND_MAIL_SUMMARY = 'send-mail-summary',
  SEND_MAIL_VACCINE = 'send-mail-vaccine',
  SIDE_BAR = 'side-bar',
  SUGESTION_LIST = 'sugestion-list',
  SUGGESTION_CHECK_AVAILABLE = 'suggestion-check-available',
  SUGGESTION_TYPE_CONSULTATION = 'suggestion-type-consultation',
  TAB_MY_CHART_ALLERGIES = 'tab-my-chart-allergies',
  TASKS = 'tasks',
  TASKS_SIDE_BAR = 'tasks-side-bar',
  TERMS_OF_USE = 'terms-of-use',
  TERMS_OF_USE_MODAL = 'terms-of-use-modal',
  UPLOAD_FILE = 'upload-file',
  VERSION = 'version',
}
export { FragmentNames };
